/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_NewInputs */

const vi_care_log_new = /** @type {(inputs: Care_Log_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm nhật ký`)
};

/**

* @param {Care_Log_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_new = /** @type {((inputs?: Care_Log_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_new(inputs)
});